export const SENTRY_RELEASE: string | undefined = 'c908d9a138db233f7101a48fd7cca3bbfb67a9a4';
